import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-semester-selector',
    templateUrl: './semester-selector.component.html',
    styleUrls: ['./semester-selector.component.css'],
    standalone: false
})
export class SemesterSelectorComponent implements OnInit {

    kodSemester = [];

    constructor(
        private appService: AppService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.kodSemester = this.appService.getSemester();
    }

    semesterChange() {
        this.appService.setSelectedSemester(
            this.kodSemester.map(s => this.translate.instant(s))
        );
    }
}
